<template>
  <g-container>
    <g-contents>
      <am-xy-chart-2 refName="srline" :chart-data="chartData" :filter="filter" series-type="LineSeries" @hit="onHit" />
      <am-xy-chart-2 refName="srline" :chart-data="chartData" :filter="filter" series-type="ColumnSeries"  @hit="onHit" />
    </g-contents>
  </g-container>
</template>
<script>
import AmXyChart2 from '../components/AmXyChart2'
import ChartDummy from './ChartDummy.json'
export default {
  name: 'AmChartSample',
  components: {AmXyChart2},
  data () {
    return {
      chartData: [],
      filter: []
    }
  },
  methods: {
    onHit (ev) {
      console.log(' >>> onHit !! <<<')

    }
  },
  beforeMount () {
    this.chartData = ChartDummy.chartData
    this.filter = ChartDummy.filter
  }
}

</script>
<style>
.chart {
  height: 320px;
}

</style>



// WEBPACK FOOTER //
// src/pages/sample/AmChartSample.vue